import FadeInWhenStart from "../../../animations/FadeInWhenStart";
import DarkModeButton from "../../../common/DarkModeButton";
import Filtertext from "../../../common/Filtertext";

const FrontPage = ({changeFilter}: {changeFilter: any}) => {


    return(
        <div className="w-full h-screen text-white flex flex-col justify-between pt-8 px-0 md:px-10 z-10" id="home">
            <div className="w-full flex justify-between">
                <FadeInWhenStart classname="w-full" delay={0.1}>
                        <div className="font-semibold flex justify-center md:justify-start w-full py-16 md:py-1">
                            <img src="/logo/logo.svg" alt="not found" className="w-60 md:w-44 hidden dark:flex "/>
                            <img src="/logo/logo.svg" alt="not found" className="w-60 md:w-44 flex dark:hidden "/>
                        </div>
                </FadeInWhenStart>
                <FadeInWhenStart classname="fixed top-6 right-8 z-50" delay={0.2}>
                    <DarkModeButton />
                </FadeInWhenStart>
            </div>
            <div className="w-full flex justify-center md:justify-between pb-40">
                    <div className="hidden text-left text-lg lg:text-xl xl:text-3xl md:flex flex-col justify-end z-10 ani-enter-bot">
                        <FadeInWhenStart delay={1.1}><span>42 IS THE ANSWER.</span></FadeInWhenStart>
                        <FadeInWhenStart delay={1.2}><span>DESIGN IS THE QUESTION.</span></FadeInWhenStart>
                    </div>
                    
                    <div className="text-md text-center md:hidden md:text-left md:text-lg lg:text-xl xl:text-3xl flex flex-col justify-end z-10 ani-enter-bot">
                        <FadeInWhenStart delay={0.3}><span>42 IS THE ANSWER.</span></FadeInWhenStart>
                        <FadeInWhenStart delay={0.4}><span>DESIGN IS THE QUESTION.</span></FadeInWhenStart>
                    </div>
                <div className="text-xs z-50 md:text-md lg:text-lg xl:text-xl hidden md:flex flex-col p-4 text-gray">
                    <FadeInWhenStart delay={0.5}><Filtertext><div className="hover:cursor-cur_hover" onClick={() => changeFilter("CORPORATE")}>CORPORATE</div></Filtertext></FadeInWhenStart>
                    <FadeInWhenStart delay={0.6}><Filtertext><div className="hover:cursor-cur_hover" onClick={() => changeFilter("MOTION")}>MOTION</div></Filtertext></FadeInWhenStart>
                    <FadeInWhenStart delay={0.7}><Filtertext><div className="hover:cursor-cur_hover" onClick={() => changeFilter("GAME")}>GAME</div></Filtertext></FadeInWhenStart>
                    <FadeInWhenStart delay={0.8}><Filtertext><div className="hover:cursor-cur_hover" onClick={() => changeFilter("OTHER")}>OTHER</div></Filtertext></FadeInWhenStart>

                </div>
            </div>
        </div>
    )
}

export default FrontPage;